module.exports = __webpack_public_path__ + "static/media/Group 11.d02cc2c6.png";